import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function ChatsPage() {
  // chats-list-page.tsx reads its own search params via useSearchParams; the
  // wrapper only needs the chatsView flag. Mirrors the Next app/chats/page.tsx
  // shape (resolvedParams: default, empty searchParams, chatsView=true).
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      chatsView
    />
  );
}
